@if (service.items.length) {
    <div class="label-switcher-menu flexbox flex-column" [ngClass]="{ 'single-page-mode': accountMenuDataService.singlePageMode }">
        @for (item of service.items; track trackByName($index, item)) {
            <div class="form-element form-element-right">
                <ds-radio-group size="large" labelPosition="left" (valueChange)="switchLabel(item)">
                    <ds-radio-button value="item.name" name="options" [class.ds-radio-selected]="item.isActive"> {{ item.text }}</ds-radio-button>
                </ds-radio-group>
            </div>
        }
    </div>
}
